function tabs(tabsSelector, tabsContentSelector, tabsParentSelector, activeClass, changeImagePaths, display = 'show') {
    try {
        let tabs = document.querySelectorAll(tabsSelector),
            tabsContent = document.querySelectorAll(tabsContentSelector),
            tabsParent = document.querySelector(tabsParentSelector),
            conceptionImg = document.querySelector(".conception__img img");
        

        const hideTabContent = () => {
            
            tabsContent.forEach(item => {
                item.classList.add('hide');
                item.classList.remove(display);
            });

            activeClass ?
            tabs.forEach(item => {
                item.classList.remove(activeClass);
            }) : null;
        };

        const showTabContent = (i = 0) => {
            tabsContent[i].classList.add(display);
            tabsContent[i].classList.remove('hide');

            activeClass ? tabs[i].classList.add(activeClass) : null;

            changeImagePaths ? conceptionImg.src = changeImagePaths[i] : null;
        };
        
        hideTabContent();
        showTabContent();

        tabsParent.addEventListener('click', function(event) {
            event.preventDefault();
            const target = event.target;
            if(target.parentElement.classList.contains(tabsSelector.slice(1)) || target.classList.contains(tabsSelector.slice(1))) {
                tabs.forEach((item, i) => {
                    if (target == item || target.parentElement == item) {
                        hideTabContent();
                        showTabContent(i);
                    }
                });
            }
        });
    } catch(e){}
}

export default tabs;